module.exports = __webpack_public_path__ + "static/media/silkeHeinz.5b599bb3.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/authorSpotlight/silkeHeinz.jpg
// module id = 1694
// module chunks = 1